<template>
	<div>
		<div class="big_screen">
			<div class="top"></div>
			<div class="time">{{ formattedTime }}</div>
			<div class="content">
				<div class="left">
					<lt></lt>
					<lc></lc>
					<lb></lb>
				</div>
				<div class="center">
					<ct></ct>
					<cb></cb>
				</div>
				<div class="right">
					<rt1></rt1>
					<rb></rb>
				</div>
			</div>
		</div>
















	</div>
</template>

<script>
	import lt from '../components/lt.vue'
	import lc from '../components/lc.vue'
	import lb from '../components/lb.vue'
	import ct from '../components/ct.vue'
	import cb from '../components/cb.vue'
	import rt1 from '../components/rt1.vue'
	import rb from '../components/rb.vue'

	import {
		report
	} from "../../api/home.js";

	export default {
		components: {
			lt,
			lc,
			lb,
			ct,
			cb,
			rt1,
			rb

		},
		data() {
			return {
				formattedTime: '',
				timer: null // 用于保存定时器ID，方便销毁
			}
		},
		mounted() {
			// 初始化时立即执行一次
			this.formatCurrentTime();
			// 启动定时器，每秒更新一次
			this.timer = setInterval(() => {
				this.formatCurrentTime();
			}, 1000);
		},
		methods: {
			formatCurrentTime() {
				const date = new Date();
				const year = date.getFullYear();
				const month = this.padZero(date.getMonth() + 1);
				const day = this.padZero(date.getDate());

				const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
				const weekDay = weekDays[date.getDay()];

				const hours = this.padZero(date.getHours());
				const minutes = this.padZero(date.getMinutes());
				const seconds = this.padZero(date.getSeconds()); // 可选：如需显示秒数

				this.formattedTime = `${year}年${month}月${day}日 ${weekDay} ${hours} : ${minutes}`;
			},
			padZero(num) {
				return num < 10 ? '0' + num : num;
			}
		}
	}
</script>

<style scoped lang="less">
	.big_screen {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		position: relative;
		background: #143441;
	}

	.top {
		width: 100vw;
		height: 90px;
		background-image: url(/src/assets/top.png);
		position: absolute;
		top: 0px;
		left: 0px;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.time {
		font-family: Source Han Sans CN;
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
		position: absolute;
		right: 28px;
		top: 54px;
		font-weight: 500;

	}

	.content {
		width: 100vw;
		position: absolute;
		left: 0px;
		top: 93px;
		height: calc(100vh - 95px);

		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.left {
		width: 28vw;
		height: calc(100vh - 95px);
		
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

	}

	.center {
		width: 44vw;
		height: calc(100vh - 95px);
		
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.right {
		width: 28vw;
		height: calc(100vh - 95px);
		
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
</style>